import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Card } from "antd";

import FormVerify from "@/components/elements/FormVerification";
import CommonFooter from "@/components/common/CommonFooter";
import CommonSlider from "@/components/common/CommonSlider";
import ProductDetail from "@/components/common/ProductDetail";
import StampStatusVerification from "@/components/elements/StampStatusVerification";
import CommonContact from "@/components/common/CommonContact";
import CustomerProfile from "@/components/common/CustomerProfile";

import { useScanQrcodeStore } from "@/store";
import { apiVerifyStampCode } from "@/api";

interface OldQrcodeTemplateProps {
  oldQrcode?: string;
}

const OldQrcodeTemplate: React.FC<OldQrcodeTemplateProps> = ({ oldQrcode = "mirascan" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [hasStampVerified, setHasStampVerified] = useState(true);

  const { params, product, setDataScanQrcode } = useScanQrcodeStore();
  const { xid, serial, preview } = params;

  const browserId = window.localStorage.getItem("browser_id");

  const handleEventSubmit = async (event: any) => {
    try {
      const data = {
        type: "landing_page",
        id: xid,
        serial: oldQrcode === "mirascan" ? xid : serial,
        ...event,
        browser_id: browserId,
        old_qrcode: oldQrcode,
        type_submit: "submit",
      };

      const response = await apiVerifyStampCode(data);
      const { data: dataResponse } = response;
      const rsStatus = dataResponse?.stamp_code?.status || "";

      if (rsStatus && rsStatus === "over_limited") {
        navigate("/over-scan");
        return;
      }

      setDataScanQrcode(dataResponse);
      setHasStampVerified(true);
    } catch (e) {
      console.log("[QRX] error handle event submit", e);
      navigate("/error");
    }
  };

  return (
    <div>
      <div className="m-auto min-h-screen">
        <Card className={`qrx-card-bank mb-3 ${!hasStampVerified ? "opacity-50" : ""}`}>
          <CommonSlider images={product?.images} />

          <div className="bg-[#4CB050] text-[16px] leading-5 p-4 text-white font-medium">
            {t("common.check_product_info")}
          </div>
        </Card>

        {!hasStampVerified ? (
          <FormVerify preview={preview} shouldShowCustomerFields onSubmit={handleEventSubmit} />
        ) : (
          <>
            <StampStatusVerification className="mb-3" />
            <CustomerProfile className="mb-3" />
            <ProductDetail className="mb-3" />
          </>
        )}

        <CommonContact />
        <CommonFooter />
      </div>
    </div>
  );
};

export default OldQrcodeTemplate;
